(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/selfservice-storage-handler/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/components/selfservice-storage-handler/assets/javascripts/prescript.js');
"use strict";

svs.components = svs.components || {};
svs.components.selfserviceStorageHandler = svs.components.selfserviceStorageHandler || {};

 })(window);